export const VariantClasses = {
  normal: 'font-normal',
  semibold: 'font-bold',
  italic: 'italic',
}

export const ColorVariantClasses = {
  gray300: 'text-gray-300',
  gray400: 'text-gray-400',
  gray500: 'text-gray-500',
  gray600: 'text-gray-600',
  gray700: 'text-gray-700',
  gray900: 'text-gray-900',
  red600: 'text-red-600',
  red700: 'text-red-700',
  red800: 'text-red-800',
  yellow600: 'text-yellow-600',
  yellow900: 'text-yellow-900',
  primary600: 'text-primary-600',
  green600: 'text-green-600',
  blue600: 'text-blue-600',
  white: 'text-white',
}

export const LeadingClasses = {
  none: 'leading-none',
  tight: 'leading-tight',
  normal: 'leading-normal',
  relaxed: 'leading-relaxed',
}

export const ClampClasses = {
  clamp0: '',
  clamp1: 't-text__clamp--1',
  clamp2: 't-text__clamp--2',
  clamp3: 't-text__clamp--3',
  clamp4: 't-text__clamp--4',
  clamp5: 't-text__clamp--5',
  clamp6: 't-text__clamp--6',
  clamp7: 't-text__clamp--7',
  clamp8: 't-text__clamp--8',
  clamp9: 't-text__clamp--9',
  clamp10: 't-text__clamp--10',
}

export const SizeClasses = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
}

export const MarginClasses = {
  xs: 'mt-0 mb-2',
  sm: 'mt-0 mb-3',
  base: 'mt-0 mb-4',
  lg: 'mt-0 mb-4',
}
